<template>
    <div>
        <div class="container">

            <div class="handle-box-search">


                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">商品名称:</span>
                        <el-input v-model="search_data.service_title" placeholder="请输入订单编码" class="handle-input mr10"
                                  style="width: 200px;" @keyup.enter.native="searchorderList">
                        </el-input>
                    </el-col>
                    <el-col :span="12">
                        <span class="title">乘客编码:</span>
                        <el-input v-model="search_data.jzuid" placeholder="请输入订单编码" class="handle-input mr10"
                                  style="width: 200px;" @keyup.enter.native="searchorderList">
                        </el-input>
                    </el-col>

                </el-row>

                <el-row class="head-search">
                    <el-col :span="24">
                        <span class="title">支付状态:</span>
                        <el-select
                                v-model="search_data.is_pay"
                                style="width: 150px; margin-right: 20px;"
                                clearable
                        >
                            <el-option
                                    label="已支付"
                                    value="1"
                            ></el-option>
                            <el-option
                                    label="未支付"
                                    value="0"
                            ></el-option>
                        </el-select>
                    </el-col>


                </el-row>





                <el-button type="primary" icon="el-icon-search" @click="searchorderList">搜索</el-button>
                <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            </div>

            <el-table :data="result_data.data" class="table" ref="multipleTable" header-cell-class-name="table-header">





                <el-table-column label="订单编码" prop="orderId" min-width="100"> </el-table-column>

                <el-table-column label="商品名称" prop="service_title" min-width="150"> </el-table-column>
                <el-table-column label="图片地址" prop="image">
                    <template slot-scope="scope">
                        <el-image :src="scope.row.image" :preview-src-list="srcList"></el-image>
                    </template>
                </el-table-column>

                <el-table-column label="支付状态" prop="image">
                    <template slot-scope="scope">
                        {{scope.row.is_pay=='0'?'待支付':scope.row.is_pay=='1'?'已支付':scope.row.is_pay=='2'?'已退款':''}}
                    </template>
                </el-table-column>
                <el-table-column label="商品价格" prop="price"> </el-table-column>
                <el-table-column label="购买数量" prop="num"> </el-table-column>
                <el-table-column label="实收金额" prop="finish_amount"> </el-table-column>
                <el-table-column label="下单时间" prop="add_time"> </el-table-column>
                <el-table-column label="预约时间" prop="yuyue_time"> </el-table-column>
                <el-table-column label="预约门店地址" prop="detaile d_address" min-width="150"> </el-table-column>
                <el-table-column label="门店客服电话" prop="customer_service_phone" min-width="150"> </el-table-column>
                <el-table-column label="商品名称" prop="service_title" min-width="150"> </el-table-column>

                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">



                        <el-dropdown split-button trigger="click" type="primary"
                                     @click="editRoleSubmitShow = !editRoleSubmitShow; editRole_data = scope.row.orderId">
                            核销列表


                            <el-dropdown-menu slot="dropdown">
<!--                                 @click.native="setNav(scope.row.admin_role_code)"-->
                                <el-dropdown-item @click.native="refund(scope.row.orderId)">退款</el-dropdown-item>
                            </el-dropdown-menu>



                        </el-dropdown>



                    </template>
                </el-table-column>
            </el-table>


            <!-- 分页组件 -->
            <div class="pagination">
                <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
            </div>

        </div>

        <!-- 编辑的弹窗子组件 -->
        <orderCodeList :isShow="editRoleSubmitShow" :editRole_data="editRole_data">
        </orderCodeList>


    </div>
</template>
<script>
    var _this;
    import orderCodeList from './orderCodeList';



    export default {

        components: {

            orderCodeList,

        },
        data() {
            return {




                srcList:[],

                search_data: {
                    page: 1,
                    limit: 10,
                    jzuid:'',
                    service_title:'',
                    is_pay:''
                },

                result_data: [],

                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: false,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    }
                },


                editRoleSubmitShow: false, //编辑的diglog

                editRole_data: ''
            };
        },

        //生命周期，建立
        created() {

            _this = this;

            //初始化显示列表
            _this.orderList();

        },
        methods: {

            refund(code){

                this.$confirm('此操作将退款, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //确定
                    _this.$post(
                        "/Tmallorder/orderRefund",
                       {
                           orderId:code
                       }
                    ).then(res => {

                        _this.orderList();
                        _this.$message.success(res.msg)

                    }).catch((err) => {

                    })

                }).catch(() => {
                    // 取消
                });

            },




            searchorderList() {
                _this.search_data.page = 1;
                _this.orderList();
            },




            //翻页组件的回调
            pages_function(search_data) {

                //赋值
                _this.search_data = search_data;

                //初始化
                _this.orderList();

            },

            //搜索角色列表
            orderList() {

                _this.$post(
                    "/Tmallorder/orderList",
                    _this.search_data,
                    _this.search_rules
                ).then(res => {

                    _this.result_data = res;

                    _this.srcList.length = 0;
                    for (let i = 0; i < res.data.length; i++) {
                        _this.srcList.push(res.data[i].image);
                    }

                }).catch((err) => {

                })

            },

            refresh() {
                this.$router.go(0);
            }

        }
    };
</script>

<style scoped>
    .checkbox {
        position: absolute;
        margin-left: 21px;
        top: 20px;
    }

    .page {
        position: absolute;
        right: 0;

    }

    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }



    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }
</style>
